import { render } from "./BoardTableTypeList.vue?vue&type=template&id=eccdd9a8&scoped=true"
import script from "./BoardTableTypeList.vue?vue&type=script&lang=js"
export * from "./BoardTableTypeList.vue?vue&type=script&lang=js"

import "./BoardTableTypeList.vue?vue&type=style&index=0&id=eccdd9a8&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eccdd9a8"]])

export default __exports__